import React from 'react';
import PropTypes from 'prop-types';
import NavIcon from './nav_icon';
import lockIconSvg from '../../svgs/lock_icon.svg';
import IconWrapper from './icon_wrapper_container';

const NavLockIcon = ({ lockIconSize }) => (
  <IconWrapper>
    <NavIcon src={lockIconSvg} alt='Secure Checkout Icon' size={lockIconSize} />
  </IconWrapper>);

if (process.env.NODE_ENV !== 'production') {
    NavLockIcon.propTypes = {
    lockIconSize: PropTypes.number.isRequired
  };
}

export default NavLockIcon;
